// src/utils/authStorage.js
const KEYS = {
  TOKEN: "token",
  USER_ID: "userId",
  USER_ROLE: "userRole",
  ME: "me",
  PENDING_LOGOUT_AT: "pendingLogoutAt",
  TAB_SESSION_ID: "tabSessionId", // sessionStorage only
};

const RELOAD_WINDOW_MS = 1500; // tweak if needed

export const authStore = {
  get token() {
    return localStorage.getItem(KEYS.TOKEN);
  },
  set token(v) {
    if (v == null) localStorage.removeItem(KEYS.TOKEN);
    else localStorage.setItem(KEYS.TOKEN, v);
  },
  get userId() {
    return localStorage.getItem(KEYS.USER_ID);
  },
  set userId(v) {
    if (v == null) localStorage.removeItem(KEYS.USER_ID);
    else localStorage.setItem(KEYS.USER_ID, v);
  },
  get userRole() {
    return localStorage.getItem(KEYS.USER_ROLE);
  },
  set userRole(v) {
    if (v == null) localStorage.removeItem(KEYS.USER_ROLE);
    else localStorage.setItem(KEYS.USER_ROLE, v);
  },
  get me() {
    const raw = localStorage.getItem(KEYS.ME);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },
  set me(obj) {
    if (!obj) localStorage.removeItem(KEYS.ME);
    else localStorage.setItem(KEYS.ME, JSON.stringify(obj));
  },

  clearAll() {
    localStorage.removeItem(KEYS.TOKEN);
    localStorage.removeItem(KEYS.USER_ID);
    localStorage.removeItem(KEYS.USER_ROLE);
    localStorage.removeItem(KEYS.ME);
    localStorage.removeItem(KEYS.PENDING_LOGOUT_AT);
    sessionStorage.removeItem(KEYS.TAB_SESSION_ID);
  },

  // --- refresh vs close helpers ---
  markPendingLogout() {
    localStorage.setItem(KEYS.PENDING_LOGOUT_AT, String(Date.now()));
  },
  cancelPendingLogout() {
    localStorage.removeItem(KEYS.PENDING_LOGOUT_AT);
  },
  processPendingLogoutOnLoad() {
    const raw = localStorage.getItem(KEYS.PENDING_LOGOUT_AT);
    if (!raw) return; // nothing to do

    const when = Number(raw);
    const age = Date.now() - when;

    // If we loaded quickly after unload, assume refresh → cancel.
    if (Number.isFinite(when) && age <= RELOAD_WINDOW_MS) {
      authStore.cancelPendingLogout();
      return;
    }

    // Otherwise treat as a genuine tab close → log out.
    authStore.clearAll();
  },

  ensureTabSession() {
    let id = sessionStorage.getItem(KEYS.TAB_SESSION_ID);
    if (!id) {
      id = Math.random().toString(36).slice(2);
      sessionStorage.setItem(KEYS.TAB_SESSION_ID, id);
    }
    return id;
  },

  // call once at app bootstrap
  installUnloadHook() {
    // mark unload (both refresh & tab close)
    window.addEventListener("beforeunload", () => {
      authStore.markPendingLogout();
    });
  },
};

export default authStore;
